module.exports = __webpack_public_path__ + "media/images/child-abuse-victimization-graph-2023-dd4f4a87b2fe03747c058408ce1fda1e.svg";